<div class="bdg-hover-btn-overlay">
  <button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu">
    <mat-icon style="background-color: transparent" *ngIf="icon; else menulabel">{{ icon }}</mat-icon>
    <ng-template #menulabel>{{ label }}</ng-template>
  </button>
</div>
<mat-menu class="bdg-menu-panel" #menu="matMenu" [xPosition]="xPosition" [yPosition]="yPosition">
  <ng-content matMenuContent></ng-content>
</mat-menu>
